import { BellaClientStorageDriver } from '../types';

const getLocalStorageDriver = () => window.localStorage as BellaClientStorageDriver;

export default getLocalStorageDriver;
